import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const StripePaymentId = (props: InputComponentProps) => {
  const validate = ({ value }) =>
    value.startsWith('pm_') ||
    "Invalid payment method Id. Payment method Id must start with 'pm_' prefix";

  return (
    <ValidatingInput
      autoComplete="stripe-payment-method-id"
      label="Payment Method ID"
      name="stripePaymentId"
      placeholder="Payment Method ID"
      validate={validate}
      {...props}
    />
  );
};
